import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private config: any;

  constructor(
    private http: HttpClient
  ) { }

  loadConfig() {
    return firstValueFrom(
      this.http.get('/assets/configuration/configuration.json')
    ).then((data: any) => {
      this.config = data;
    });
  }

  get setting() {
    return this.config;
  }
}